<template>
  <div class="columns">
    <div class="breadcrumb-nav column is-offset-1">
      <p v-for="c in crumbs" :key="c.text">
        <router-link :to="c.l" v-if="c.l">{{c.text}} </router-link>
        <span v-else> {{c.text}} </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'breadcrumbs',

  props: ['crumbs'],
};
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue